import { useState, useEffect } from 'react';

export function useViewport() {
  const [size, setSize] = useState(() => ({ width: window.innerWidth, height: window.innerHeight }));
  useEffect(() => {
    const update = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return size;
}

// Tablets and short landscape windows cannot support two persistent sidebars.
export function useIsMobile() {
  const { width, height } = useViewport();
  return width < 1200 || height < 500;
}
